<template>
    <admin-page :result="result" description="Borra la cuenta por email y libera el email para re-invitarlo">
        <div class="danger-note">
            <v-icon size="18" color="error">mdi-alert-outline</v-icon>
            <span>Esta acción es irreversible.</span>
        </div>

        <div class="form-row">
            <kimsa-text-field class="form-field" @change="email = $event" :value="email" label="Email del usuario"
                placeholder="usuario@correo.com" dense hide-details />
            <v-btn color="error" class="form-btn" depressed :loading="loading" :disabled="!email" @click="showConfirm">
                Borrar usuario
            </v-btn>
        </div>

        <kimsa-confirm ref="confirm" alert-mode show-cancel title="Borrar usuario"
            :content="confirmContent" :persistent="false" :close-on-confirm="false" :loading="loading"
            @confirm="deleteUser" />
    </admin-page>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import KimsaTextField from '@/components/common/inputs/KimsaTextField.vue'
import KimsaConfirm from '@/components/common/KimsaConfirm.vue'
import AdminPage from '@/components/admin/AdminPage.vue'
import { adminRouteGuard } from '@/utils/Admin'

export default {
    name: 'AdminDeleteUser',
    components: { KimsaTextField, KimsaConfirm, AdminPage },
    beforeRouteEnter: adminRouteGuard,
    data() {
        return {
            email: '',
            loading: false,
            result: null,
        }
    },
    computed: {
        confirmContent(vm = this) {
            return `Vas a borrar por completo la cuenta de <b>${vm.email.trim()}</b> (Auth + users + deletedAccounts). Esta acción es irreversible.`
        },
    },
    mounted() {
        const vm = this
        if (vm.$route.query.email) vm.email = vm.$route.query.email
    },
    methods: {
        showConfirm() {
            if (!this.email.trim()) return
            this.$refs.confirm.show()
        },
        async deleteUser() {
            const vm = this
            const email = vm.email.trim()
            if (!email) return
            vm.loading = true
            vm.result = null
            try {
                const fn = firebase.functions().httpsCallable('httpAdmin-purgeUser')
                const { data } = await fn({ email })
                vm.result = {
                    type: 'success',
                    message: `Listo. ${email}: Auth ${data.deletedAuth ? 'borrado' : 'no existía'}, ${data.deletedUserDocs} doc(s) users, ${data.deletedDeletedAccountDocs} doc(s) deletedAccounts.`
                }
                vm.email = ''
            } catch (err) {
                console.error('[adminPurgeUser] error', err)
                vm.result = {
                    type: 'error',
                    message: err.message || 'Error al borrar el usuario.'
                }
            } finally {
                vm.loading = false
                vm.$refs.confirm?.hide()
            }
        },
    },
}
</script>

<style scoped>
.danger-note {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding: 10px 12px;
    border-radius: 10px;
    background: rgba(232, 92, 92, 0.08);
    border: 1px solid rgba(232, 92, 92, 0.28);
    color: var(--v-error-base);
    font-size: 12px;
    font-weight: 600;
}

.form-row {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
}

.form-field {
    flex: 1;
    min-width: 240px;
}

.form-btn {
    height: 40px !important;
    min-width: 140px;
    border-radius: 8px;
}

@media (max-width: 600px) {
    .form-btn {
        width: 100%;
    }
}
</style>
